export enum ActivityTypeLimited {
	DoNothing = 8,
	Points = 12,
	GiveMission = 14,
	StartAnotherCampaign = 15,
	MiniGameAttempt = 16,
	DeductPoints = 21,
	ResetPoints = 22,
	AddGemsAndDiamonds = 25,
	DeductGemsAndDiamonds = 26,
	ResetGemsAndDiamonds = 27,
	Popup = 30,
	Inbox = 31,
	Slack = 70,
	Email_To_Customer_Support = 80,
	Email_To_Risk_Operator = 90,
	Bonus = 100,
	WebHook = 200,
	TagCustomer = 504,
	UnTagCustomer = 505,
}
